import { Component, HostBinding, Input } from '@angular/core';

export enum SpinnerSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
}

export enum SpinnerBackgroundColor {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum SpinnerColor {
  PRIMARY = 'primary',
  GRAY = 'gray',
  LIGHT = 'light',
}

@Component({
  selector: 'fl-spinner',
  template: `
    <fl-bit
      class="Spinner"
      role="presentation"
      [attr.data-color]="overlay ? SpinnerColor.PRIMARY : color"
      [attr.data-size]="size"
    ></fl-bit>
  `,
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  SpinnerColor = SpinnerColor;

  @Input() size: SpinnerSize = SpinnerSize.MID;
  @Input() color: SpinnerColor = SpinnerColor.PRIMARY;

  @HostBinding('attr.data-background')
  @Input()
  backgroundColor: SpinnerBackgroundColor = SpinnerBackgroundColor.LIGHT;

  @HostBinding('class.Overlay')
  @Input()
  overlay = false;

  @HostBinding('class.IsModalOverlay')
  @Input()
  overlayForModal = false;
}
